export const SITE_THEMES = {
  lakeview: "lakeview",
  asinluxurybungalow: "asinluxurybungalow",
  takofy: "takofy",
  kelebekvadisi: "kelebekvadisi",
};

export function resolveSiteThemeKey(hostname) {
  const host = String(hostname || "").toLowerCase();

  if (host.includes("lakeviewvillaresort")) return SITE_THEMES.lakeview;
  if (host.includes("asinluxurybungalow")) return SITE_THEMES.asinluxurybungalow;
  if (host.includes("takofy")) return SITE_THEMES.takofy;

  if (host.includes("kelebekvadibungalov") || host.includes("kelebekvadisi")) {
    return SITE_THEMES.kelebekvadisi;
  }

  return SITE_THEMES.lakeview;
}
